import * as url from "../url.helper";

import { post } from "../api.helper";

export const addDeal = data => post(url.ADD_DEAL, data);

export const addDealDraft = data => post(url.ADD_DEAL_DRAFT, data);

export const editDealDraft = data => post(url.EDIT_DEAL_DRAFT, data);

export const getDeal = data => post(url.GET_DEAL, data);

export const getDoc = data => post(url.GET_DOCUMENTS, data);

export const getDealForTabs = data => post(url.GET_DEAL_FOR_TABS, data);

export const getEntityWiseDeal = data => post(url.GET_ENTITYWISE_DEAL, data);

export const editDeal = data => post(url.EDIT_DEAL, data);

export const allEntity = data => post(url.ALL_ENTITY, data);

export const getDealInfo = data => post(url.GET_DEALINFO, data);

export const allFinancier = data => post(url.ALL_FINANCIER, data);

export const getDealLogs = data => post (url.GET_DEAL_LOGS, data);

export const getTemplateValues = data => post (url.GET_TEMPLATE_VALUES, data);

export const digioSignRequestForMou = data => post (url.DIGIO_SIGN_REQUEST_MOU, data);

export const digioSignRequest = data => post(url.DIGIO_SIGN_REQUEST, data);

export const digioManualSignRequest = data => post(url.DIGIO_MANUAL_SIGN_REQUEST, data);

export const digioManualSignRequestMoU = data => post(url.DIGIO_MANUAL_SIGN_REQUEST_MOU, data);

export const saveDigioResponse = data => post(url.SAVE_DIGIO_RESPONSE, data);

export const saveDigioResponseMou = data => post(url.SAVE_DIGIO_RESPONSE_MOU, data);

export const downloadDealPdf = data => post(url.DOWNLOAD_DEAL_PDF, data)

export const getOneDeal = data => post(url.GET_ONE_DEAL, data)

export const addMandate = data => post(url.ADD_MANDATE, data);

export const downloadCamProfile = data =>post(url.DOWNLOAD_CAM_PROFILE, data)

export const downloadCamProfileWord = data =>post(url.DOWNLOAD_CAM_PROFILE_WORD, data)

export const getMandate = data => post(url.GET_MANDATE, data);

export const addMOU = data => post(url.ADD_MOU, data);

export const getMou = data => post(url.GET_MOU, data);

export const downloadMandate = data => post(url.DOWNLOAD_MANDATE, data);

export const addDealStatus = data => post(url.ADD_DEAL_STATUS, data);

export const dealSummary = data => post(url.DEAL_SUMMARY, data);

export const dealFinancierDetails = data => post(url.DEAL_FINANCIER_DETAILS, data);

export const addDealTermsheet = data => post(url.ADD_DEAL_TERMSHEET, data)

